import { Link } from "react-router-dom";
import { ArrowLeft, Plus } from "lucide-react";
import { useTranslation } from "@/shared/providers/LanguageProvider";
import { useToast } from "@/shared/providers/ToastProvider";
import { Breadcrumbs } from "../components/Breadcrumbs";
import { StandardDiagnosticCodeForm } from "../components/StandardDiagnosticCodeForm";
import { createAdminDiagnosis } from "../api/adminApi";
import { getAuthToken } from "../auth";
import {
  createStandardDiagnosticCode,
  loadStandardDiagnosticCodes,
} from "../standardDiagnosticCodesStorage";

export function AddStandardDiagnosticCodePage() {
  const { t } = useTranslation();
  const labels = t.safecheck.acts.standardDiagnostics.create;
  const { showToast } = useToast();

  return (
    <>
      <Breadcrumbs
        items={[
          { label: t.safecheck.nav.acts },
          { label: t.safecheck.acts.standardDiagnostics.title, href: "/dashboard/acts/standard-diagnostics" },
          { label: labels.title },
        ]}
      />

      <div className="mb-4 flex justify-end">
        <Link
          to="/dashboard/acts/standard-diagnostics"
          className="inline-flex items-center gap-2 rounded-lg border border-border bg-card px-3 py-2 text-sm text-muted-foreground transition-colors hover:bg-card-muted"
        >
          <ArrowLeft size={14} />
          {t.safecheck.back}
        </Link>
      </div>

      <div className="theme-card p-6">
        <div className="mb-6 flex items-center gap-2 text-base font-semibold text-foreground">
          <Plus size={16} className="text-primary" />
          {labels.cardTitle}
        </div>

        <StandardDiagnosticCodeForm
          labels={labels}
          cancelHref="/dashboard/acts/standard-diagnostics"
          onSubmit={async (values) => {
            if (!getAuthToken()) {
              createStandardDiagnosticCode(loadStandardDiagnosticCodes(), values);
              showToast(t.actions.saved);
              return;
            }
            await createAdminDiagnosis({
              code: values.code,
              label: values.label,
              type: values.type,
              description: values.description,
            });
            showToast(t.actions.saved);
          }}
        />
      </div>
    </>
  );
}
